import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card/Card.js';
import { customerActions } from '../../_actions/customer.actions.js';
import { useDispatch, useSelector } from 'react-redux';
import TableComponent from './Table/TableComponent.js';
import BarCharts from '../../components/ui/BarCharts/BarCharts.js';


const Dashboard = () => {
  const dispatch = useDispatch();
  const selector = useSelector(state => state)
  const customers = useSelector(state => state.customer.customer);
  const analyticsCount = useSelector(state => state.customer.analyticsCount);
  const [selectedFilter, setSelectedFilter] = useState("MONTH");
  const [selectedCustomer, setSelectedCustomer] = useState("Total");
  const [dataSelected, setSelectedData] = useState("");
  const date = new Date();
  let cred = {
    "filter": selectedFilter,
    "year": `${date.getFullYear()}`,
    "month": `${date.getMonth()+1}`,
    "data": dataSelected
  }
  useEffect(() => {
    dispatch(customerActions.customerList({ sortOrder: "DESC", size: 5 }));
    dispatch(customerActions.getAlalyticsCount({}));
    dispatch(customerActions.getGraphData(cred));
  }, []);



  const graphData = selector?.customer?.graphDataList || [];
  function percentage(oldV, newV) {
    oldV = +(oldV);
    newV = +(newV);
    if (oldV === 0) {
      return { change: "0.00%", isPositive: true };
    }
    if (newV === 0) return { change: "0.00%", isPositive: false }

    const getProductDetailsChange = ((newV - oldV) / Math.abs(oldV)) * 100;
    const isPositive = getProductDetailsChange >= 0;
    const sign = isPositive ? "+" : "-";

    return {
      change: `${sign}${Math.abs(getProductDetailsChange).toFixed(2)}%`,
      isPositive: isPositive
    };
  }

  const tableHeaders = [
    "Id",
    "Name",
    "Phone",
    "City",
    "Weighbridge Id",
    "License Key",
    "Referred By",
    "Expired On",
    "Login",
  ];

  const changeGrapgh = (data = '') => {
    if(data) {
      cred.data = data;
      setSelectedData(data);
      if(data==='active') {
        setSelectedCustomer("Active");
      } else if(data==="expired") {
        setSelectedCustomer("Near Expiry");
        data = "expired2";
      }
    } else {
      cred.data = "";
      setSelectedCustomer("Total");
      setSelectedData("");
    }
    dispatch(customerActions.getGraphData(cred));
    dispatch(customerActions.customerList({ sortOrder: "DESC", sortBy: data || "created_at", size: 5 }));
  }
  const handleOnChange = (e) => {
    const type = e.target.value;
    if(type==="TODAY") {
      setSelectedFilter("TODAY");
      cred.filter = "TODAY";
    } else if(type === "WEEK") {
      setSelectedFilter("WEEK");
      cred.filter = "WEEK";
    } else if(type==='MONTH') {
      setSelectedFilter("MONTH");
      cred.filter = "MONTH";
    } else if(type==='YEAR') {
      setSelectedFilter("YEAR");
      cred.filter = "YEAR";
    } else {
      setSelectedFilter("YEAR");
      cred.filter = "YEAR";
    }
    dispatch(customerActions.getGraphData(cred));
    dispatch(customerActions.customerList({ sortOrder: "DESC", sortBy: cred?.data || "created_at", size: 5 }));
  }

  return (
    <div>
      <div className="z-0 overflow-hidden h-screen overflow-y-auto focus:outline-none backbg">
        <div className="relative">
          <div className="relative z-20 flex min-h-screen">
            <div className="flex w-full overflow-hidden ">
              <div className="flex flex-col flex-1 overflow-hidden">
                <main className="relative flex-1 pb-20">
                  <div className="md:p-6 p-4">
                    <div className="mx-auto max-w-screen-3xl space-y-4">
                      <sectiion className="flex justify-between">
                        {analyticsCount && <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 place-items-center gap-4 w-full'>
                          <Card
                            title="TOTAL CUSTOMERS"
                            count={analyticsCount?.total || 0}
                            percentage={percentage(analyticsCount.yesterdayTotal, analyticsCount.total)}
                            description="Up from yesterday"
                            name=""
                            handleClick={changeGrapgh}
                            tabIndex={1}
                          />
                          <Card
                            title="ACTIVE CUSTOMERS"
                            count={analyticsCount?.activeTotal || 0}
                            percentage={percentage(analyticsCount.yesterdayActivTotal, analyticsCount.activeTotal)}
                            description="Up from yesterday"
                            isGreen={false}
                            name='active'
                            handleClick={changeGrapgh}
                            tabIndex={2}
                          />
                          <Card
                            title="Near Expiry"
                            count={analyticsCount?.expiredTotal || 0}
                            percentage={percentage(analyticsCount.yesterdayExpiredTotal, analyticsCount.expiredTotal)}
                            description="Up from yesterday"
                            name='expired'
                            handleClick={changeGrapgh}
                            tabIndex={3}
                          />
                          <Card
                            title="City Status"
                            count={analyticsCount?.total || 0}
                            percentage=""
                            description=""
                            name=''
                            handleClick={changeGrapgh}
                            tabIndex={4}
                          />
                        </div>}
                      </sectiion>
                      <section className='bg-white p-2 rounded-md border border-[#2121211A]/10'>
                        <div className='flex justify-between items-center p-2'>
                          <h2 className='text-lg font-semibold'>{selectedCustomer} Customers</h2>
                          <div className='md:space-x-2 space-x-0'>
                            <select onChange={(e) => handleOnChange(e)} value={selectedFilter} className='px-2 py-1.5 bg-white border rounded-md outline-none'>
                              <option value="TODAY">Today</option>
                              <option value="WEEK">This Week</option>
                              <option value="MONTH">This Month</option>
                              <option value="YEAR">This Year</option>
                            </select>
                          </div>
                        </div>
                        <BarCharts graphData={graphData} />
                      </section>
                      <TableComponent selectedCustomer={selectedCustomer} tableHeaders={tableHeaders} tableData={customers} />
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dashboard

